import NewHome from './new-home'

// A pagina inicial é a new-home
export default function Index() {
  return <NewHome />
}
